import * as yup from 'yup'

export const getFacilitiesFormSchema = () =>
	yup.object({
		facilities: yup.array().of(yup.string().notRequired()),
	})
